import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import { getProfileImageWithFallback } from '../../utils/profileImageUtils';

const RandomGirlsModule = ({ tripPlanId, bookedGirlIds = [] }) => {
  const [randomGirls, setRandomGirls] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (tripPlanId) {
      fetchRandomGirls();
    }
  }, [tripPlanId, bookedGirlIds]);

  const fetchRandomGirls = async () => {
    try {
      setLoading(true);
      
      // ดึงน้องทั้งหมด
      const girlsRef = collection(db, 'girls');
      const snapshot = await getDocs(girlsRef);
      
      const allGirls = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // กรองน้องที่ยืนยันแล้วออกจากการสุ่ม
      const availableGirls = allGirls.filter(girl => !bookedGirlIds.includes(girl.id));

      // สุ่มเลือก 3 คนจากน้องที่เหลือ
      const shuffled = availableGirls.sort(() => 0.5 - Math.random());
      const selectedGirls = shuffled.slice(0, 3).map(girl => ({
        id: girl.id,
        nickname: girl.nickname,
        image: getProfileImageWithFallback(girl, '/default-avatar.png'),
        status: 'available'
      }));
      
      console.log('RandomGirlsModule: สุ่มน้อง3คน', {
        totalAvailable: availableGirls.length,
        selectedCount: selectedGirls.length,
        selectedGirls: selectedGirls.map(g => ({ id: g.id, nickname: g.nickname }))
      });
      
      setRandomGirls(selectedGirls);
    } catch (error) {
      console.error('Error fetching random girls:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex space-x-2">
        {[1, 2, 3].map(i => (
          <div key={i} className="w-12 h-12 bg-gray-200 rounded-full animate-pulse"></div>
        ))}
      </div>
    );
  }

  if (randomGirls.length === 0) {
    return (
      <div className="text-xs text-gray-500">
        ไม่มีน้องว่างให้เลือก
      </div>
    );
  }

  return (
    <div className="flex space-x-2">
      {randomGirls.map((girl) => (
        <div
          key={`random-${girl.id}`}
          className="relative group cursor-pointer"
          title={`${girl.nickname} - คลิกเพื่อจอง`}
          onClick={() => {
            // Navigate to home page to see all girls
            window.location.href = '/';
          }}
        >
          {/* Profile Image with Red Border */}
          <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-red-500 shadow-md hover:border-red-600 transition-colors">
            <img
              src={girl.image}
              alt={girl.nickname}
              className="w-full h-full object-cover"
            />
          </div>
          
          {/* Red Plus for available girls */}
          <div className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center">
            <span className="text-xs font-bold">+</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RandomGirlsModule;







